const routes = [
  {
    path: '/candidate',
    component: () => import('@/layouts/WpLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/login',
      },
      {
        path: 'login',
        name: 'candidate-login',
        component: () => import('@/pages/Candidate/CandidateLogin.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_LOGIN_URL_FOR_CANDIDATE,
        },
      },
      {
        path: 'get-started',
        name: 'candidate-get-started',
        component: () => import('@/pages/Candidate/CandidateGetStarted.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_SIGN_UP_URL_FOR_CANDIDATE,
        },
      },
      {
        path: 'landing',
        name: 'candidate-landing',
        component: () => import('@/pages/Candidate/CandidateLanding.vue'),
        meta: {
          rule: 'any',
          wpUrl: '',
        },
      },
    ],
  },
  {
    path: '/candidate',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/welcome',
      },
      {
        path: 'welcome',
        name: 'candidate-welcome',
        component: () => import('@/pages/Candidate/CandidateWelcome.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Welcome',
          hideNav: true,
        },
      },
      {
        path: 'dashboard',
        name: 'candidate-dashboard',
        component: () => import('@/pages/Candidate/CandidateDashboard.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Dashboard',
        },
      },
      {
        path: 'instructions',
        name: 'candidate-instructions',
        component: () => import('@/pages/Candidate/CandidateInstructions.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Instructions',
        },
      },
      {
        path: 'update',
        name: 'candidate-update',
        component: () => import('@/pages/Candidate/CandidateUpdate.vue'),
        meta: {
          rule: 'candidate',
        },
      },
      {
        path: 'user-profile',
        name: 'candidate-user-profile',
        component: () => import('@/pages/Basic/UserProfile.vue'),
        meta: {
          rule: 'candidate',
        },
      },
      {
        path: 'profile',
        name: 'candidate-profile-read',
        component: () =>
          import('@/pages/Candidate/Profile/CandidateProfileRead.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Candidate Profile',
          dark: true,
        },
      },
      {
        path: 'profile/update',
        name: 'candidate-profile-update',
        component: () =>
          import('@/pages/Candidate/Profile/CandidateProfileUpdate.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Candidate Profile',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          appBarActions: (actions: [] | null = null) => {
            if (actions) {
              return actions;
            }

            return [
              {
                name: 'READ',
                label: 'Review Answers',
              },
            ];
          },
        },
      },
      {
        path: 'thank-you',
        name: 'candidate-thank-you',
        component: () => import('@/pages/Candidate/ThankYou.vue'),
        props: true,
        meta: {
          rule: 'candidate',
          pageTitle: 'Thank You',
          hideAppBar: true,
        },
      },
      // =============================================================================
      // Questionnaire Routes
      // =============================================================================
      {
        path: ':beOid/questionnaire/start',
        name: 'candidate-start-selected-questionnaire',
        component: () =>
          import('@/pages/Candidate/Questionnaire/CandidateQuestionnaire.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: ' ',
          dark: true,
          hideNav: true,
          redirect: 'leave',
          appBarActions: (actions: [] | null = null) => {
            if (actions) {
              return actions;
            }

            return [
              {
                name: 'UPDATE',
                label: 'Save & Exit',
                redirect: 'leave',
              },
            ];
          },
        },
      },
      // =============================================================================
      // Booking Candidate Routes
      // =============================================================================
      {
        path: 'booking-candidates',
        name: 'candidate-booking-candidate-list',
        component: () =>
          import('@/pages/Candidate/BookingCandidate/BookingCandidateList.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'candidate-dashboard',
              }),
            },
            {
              text: 'My History',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'booking-candidates/:bookingCandidateOid',
        name: 'candidate-booking-candidate-read',
        component: () =>
          import('@/pages/Candidate/BookingCandidate/BookingCandidateRead.vue'),
        meta: {
          rule: 'candidate',
          pageTitle: 'Quescreen',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'candidate-dashboard',
              }),
            },
            {
              text: 'My History',
              'active-class': '',
              to: () => ({
                name: 'candidate-booking-candidate-list',
              }),
            },
            {
              text: 'View Quescreen',
              disabled: true,
            },
          ],
        },
      },
      {
        path:
          'booking-candidates/:bookingCandidateOid/report/:questionnaireAnswerOid',
        name: 'candidate-booking-candidate-report',
        component: () =>
          import(
            '@/pages/Candidate/BookingCandidate/BookingCandidateReport.vue'
          ),
        meta: {
          rule: 'candidate',
          dark: true,
          hideNav: true,
        },
      },
      {
        path:
          'booking-candidates/:bookingCandidateOid/health-check-summary/:questionnaireAnswerOid',
        name: 'candidate-booking-candidate-health-check-summary',
        component: () =>
          import('@/pages/Candidate/HealthCheckSummary/Index.vue'), // TODO
        meta: {
          rule: 'candidate',
          dark: true,
          hideNav: true,
        },
      },
      // =============================================================================
      // Service Order
      // =============================================================================
      // {
      //   path: 'service-orders/create',
      //   name: 'candidate-service-order-create',
      //   component: () => import('@/pages/Candidate/ServiceOrder/ServiceOrderCreate.vue'),
      //   meta: {
      //     rule: 'candidate',
      //     pageTitle: 'Purchase Quescreen',
      //     dark: true,
      //     hideNav: true,
      //     redirect: 'leave',
      //     breadcrumbs: [
      //       {
      //         text: 'Dashboard',
      //         to: () => ({
      //           name: 'candidate-dashboard',
      //         })
      //       },
      //       {
      //         text: 'Purchase Quescreen or Additional Services',
      //         'active-class': '',
      //         to: () => ({
      //           name: 'candidate-service-order-list',
      //         })
      //       },
      //       {
      //         text: 'Purchase Quescreen',
      //         disabled: true
      //       }
      //     ]
      //   },
      // },
      // {
      //   path: 'service-orders/:serviceOrderOid',
      //   name: 'candidate-service-order-read',
      //   component: () => import('@/pages/Candidate/ServiceOrder/ServiceOrderRead.vue'),
      //   meta: {
      //     rule: 'candidate',
      //     pageTitle: 'View Service Order',
      //     breadcrumbs: [
      //       {
      //         text: 'Dashboard',
      //         to: () => ({
      //           name: 'candidate-dashboard',
      //         })
      //       },
      //       {
      //         text: 'Purchase Quescreen or Additional Services',
      //         'active-class': '',
      //         to: () => ({
      //           name: 'candidate-service-order-list',
      //         })
      //       },
      //       {
      //         text: 'View Service Order',
      //         disabled: true
      //       }
      //     ]
      //   },
      // },
      // {
      //   path: 'service-orders',
      //   name: 'candidate-service-order-list',
      //   component: () => import('@/pages/Candidate/ServiceOrder/ServiceOrderList.vue'),
      //   meta: {
      //     rule: 'candidate',
      //     pageTitle: ' ',
      //     breadcrumbs: [
      //       {
      //         text: 'Dashboard',
      //         to: () => ({
      //           name: 'candidate-dashboard',
      //         })
      //       },
      //       {
      //         text: 'Purchase Quescreen or Additional Services',
      //         disabled: true
      //       }
      //     ]
      //   },
      // },
    ],
  },
];

export default routes;
